export const chatbotActions = {

    GET_CHATBOT_TYPES: 'GET_CHATBOT_TYPES',
    SET_CHATBOT_TYPES: 'SET_CHATBOT_TYPES',

    GET_CHATBOTS: 'GET_CHATBOTS',
    SET_CHATBOTS: 'SET_CHATBOTS',
    GET_CHATBOT_BY_ID: 'GET_CHATBOT_BY_ID',
    SET_CHATBOT_BY_ID: 'SET_CHATBOT_BY_ID',

    GET_CHATBOT_CONFIGURATION: 'GET_CHATBOT_CONFIGURATION',
    SET_CHATBOT_CONFIGURATION: 'SET_CHATBOT_CONFIGURATION',
    UPDATE_CHATBOT_CONFIGURATION: 'UPDATE_CHATBOT_CONFIGURATION',
    DELETE_CHATBOT_CONFIGURATION: 'DELETE_CHATBOT_CONFIGURATION',

    GET_CHATBOTS_WITH_CREDENTIALS: 'GET_CHATBOTS_WITH_CREDENTIALS',
    SET_CHATBOTS_WITH_CREDENTIALS: 'SET_CHATBOTS_WITH_CREDENTIALS',
    GET_CHATBOT_CREDENTIALS: 'GET_CHATBOT_CREDENTIALS',
    GET_CHATBOT_CONNECTION: 'GET_CHATBOT_CONNECTION',
    TEST_CHATBOT_CONNECTION: 'TEST_CHATBOT_CONNECTION',

    REFRESH_DELETE_CHATBOT: 'REFRESH_DELETE_CHATBOT',
    POST_CHATBOT_CREDENTIALS: 'POST_CHATBOT_CREDENTIALS',
    POST_CHATBOT_CONNECTION: 'POST_CHATBOT_CONNECTION',
    REUSLT_TEST_CHATBOT_CONNECTION: 'REUSLT_TEST_CHATBOT_CONNECTION',

};

const initState = {
    chatbots: [],
    chatbot_types: [],
    chatbot_configuration: [],
    chatbots_with_credentials: [],
    test: {},
    chatbot: {}

};

export const chatbotReducer = (state = initState, action: any) => {
    switch (action.type) {
    case chatbotActions.SET_CHATBOT_TYPES:
        return Object.assign({}, state, { chatbot_types: action.payload });

    case chatbotActions.SET_CHATBOTS:
        return Object.assign({}, state, { chatbots: action.payload });
    case chatbotActions.SET_CHATBOTS_WITH_CREDENTIALS:
        return Object.assign({}, state, { chatbots_with_credentials: action.payload });
    case chatbotActions.SET_CHATBOT_BY_ID:
        return Object.assign({}, state, { chatbot: action.payload });
    case chatbotActions.REUSLT_TEST_CHATBOT_CONNECTION:
        return Object.assign({}, state, { test: action.payload });
    case chatbotActions.REFRESH_DELETE_CHATBOT:
        const indexOfDeletedChatbot = state.chatbots.findIndex(value => value.ID === action.payload);
        const chatbotExist = state.chatbots.filter((item: any) => item.ID !== action.payload);
        const newSelectedChatbot = (indexOfDeletedChatbot !== -1 && chatbotExist.length > indexOfDeletedChatbot) ?
            indexOfDeletedChatbot : 0;
        return Object.assign({}, state, {
            chatbots: chatbotExist || null,
            chatbot: chatbotExist ? chatbotExist[newSelectedChatbot] : null
        });

    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/reducers/chatbotReducer.ts